import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import NavigationHide from '../../hide'
import NavigationTeaser, {hasNavigationTeaserContent} from '../../navigation-teaser'
import FlyoutNavigationLevel3Breadcrumb from './flyout-navigation-level3-breadcrumb'
import {flyoutNavigationLevel3TeasersRecipe} from './flyout-navigation-level3-teasers.recipe'

/** The authored type rendered by this teaser-only level-3 pane. */
export const NAVIGATION_LEVEL3_TEASERS = 'navigationLevel3Teasers'

/**
 * Teaser-only level-3 pane.
 *
 * @param {Object} props
 * @param {Object} props.nextLevel - The teaser-only level-3 subtree.
 * @param {string} [props.title] - Current level title.
 * @param {string} [props.parentTitle] - Parent category title.
 * @param {Function} props.onBack - Returns to the level-2 pane.
 * @returns {JSX.Element|null}
 */
const FlyoutNavigationLevel3Teasers = ({nextLevel, title, parentTitle, onBack}) => {
    const recipe = useSlotRecipe({recipe: flyoutNavigationLevel3TeasersRecipe})
    const styles = useMemo(() => recipe(), [recipe])
    const teaserOnlyItems = useMemo(
        () => (nextLevel?.teaser || []).filter(hasNavigationTeaserContent).slice(0, 4),
        [nextLevel]
    )

    if (!nextLevel) return null

    return (
        <Box css={styles.root}>
            <FlyoutNavigationLevel3Breadcrumb
                title={title}
                parentTitle={parentTitle}
                onBack={onBack}
            />
            <Box css={styles.teaserOnly}>
                <Box css={styles.teaserOnlyItems} as="ul" aria-label={title}>
                    {teaserOnlyItems.map((item, idx) => (
                        <NavigationHide asChild hide={item.hide} key={idx}>
                            <Box as="li" css={styles.teaserOnlyItem}>
                                <NavigationTeaser {...item} variant="large" />
                            </Box>
                        </NavigationHide>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

FlyoutNavigationLevel3Teasers.propTypes = {
    nextLevel: PropTypes.object.isRequired,
    title: PropTypes.string,
    parentTitle: PropTypes.string,
    onBack: PropTypes.func.isRequired
}

export default FlyoutNavigationLevel3Teasers
